import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {User} from '../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private API_URL= environment.API_URL;
    private MODEL_URL='users';

    constructor(private http: HttpClient) { }

    getUsers(): Observable<User[]> {
        return this.http.get<User[]>(this.API_URL + this.MODEL_URL);
    }

    getTechniciens(): Observable<User[]> {
        return this.http.get<User[]>(this.API_URL + this.MODEL_URL + '/get-techniciens');
    }

    getUser(id: number): Observable<User>{
        return this.http.get<User>(this.API_URL + this.MODEL_URL + '/' + id).pipe(
            catchError(err => throwError(err))
        );
    }

    store(user: User): Observable<User>{
        return this.http.post<User>(this.API_URL + this.MODEL_URL, user).pipe(
            catchError(err => throwError(err))
        );
    }

    update(user: User, id: number): Observable<User>{
        return this.http.put<User>(this.API_URL + this.MODEL_URL + '/' + id, user).pipe(
            catchError(err => throwError(err))
        );
    }

    delete(id: number): Observable<any>{
        return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
            catchError(err => throwError(err))
        );
    }
}
